module.exports = __webpack_public_path__ + "static/media/Travant_Full_Logo.84649a64.png";